export const UPLOAD_DOCUMENTS_FLOW_STEPS = {
  VERIFY_IDENTITY: '1',
  ADD_A_GUARANTOR: '2',
  UPLOAD_GUARANTOR_DOCUMENTS: '3',
  ADD_ANOTHER_GUARANTOR_OR_FINISH: '4',
  WAIT_FOR_CONFIRMATION: '5',
};

export const DOCUMENTS_SIDES = {
  FRONT: 'document_front',
  REAR: 'document_rear',
};

export const USERS_TYPES = {
  ITALIAN_STUDENT: 'italianStudent',
  FOREIGN_STUDENT: 'foreignStudent',
  SELF_EMPLOYED: 'selfEmployed',
  EMPLOYEE: 'employee',
  UNEMPLOYED: 'unemployed',
  RETIRED: 'retired',
  PENSIONER: 'pensioner',
};

export const GUARANTOR_DOCS_DESCRIPTIONS = {
  UNIVERSITY_CERTIFICATION: 'universityCertification',
  BANK_ACCOUNT_BALANCE: 'bankAccountBalance',
  LAST_INCOME_TAX_RETURN: 'lastIncomeTaxReturn',
  SECOND_LAST_INCOME_TAX_RETURN: 'secondLastIncomeTaxReturn',
  LATEST_ACCOUNT_STATEMENT: 'latestAccountStatement',
  PENULTIMATE_ACCOUNT_STATEMENT: 'penultimateAccountStatement',
  PREPENULTIMATE_ACCOUNT_STATEMENT: 'prepenultimateAccountStatement',
  WORK_CONTRACT: 'workContract',
  LAST_PAYCHECK: 'lastPaycheck',
  SECOND_LAST_PAYCHECK: 'secondLastPaycheck',
  THIRD_LAST_PAYCHECK: 'thirdLastPaycheck',
  LAST_PENSION_SLIPS: 'lastPensionSlip',
  SECOND_LAST_PENSION_SLIPS: 'penultimatePensionSlip',
};

export const TENANT_DOCS_DESCRIPTIONS = {
  UNIVERSITY_CERTIFICATION: 'universityCertification',
  BANK_ACCOUNT_BALANCE: 'bankAccountBalance',
  LATEST_ACCOUNT_STATEMENT: 'latestAccountStatement',
  PENULTIMATE_ACCOUNT_STATEMENT: 'penultimateAccountStatement',
  PREPENULTIMATE_ACCOUNT_STATEMENT: 'prepenultimateAccountStatement',
  LAST_INCOME_TAX_RETURN: 'lastIncomeTaxReturn',
  SECOND_LAST_INCOME_TAX_RETURN: 'secondLastIncomeTaxReturn',
  WORK_CONTRACT: 'workContract',
  LAST_PAYCHECK: 'lastPaycheck',
  SECOND_LAST_PAYCHECK: 'secondLastPaycheck',
  THIRD_LAST_PAYCHECK: 'thirdLastPaycheck',
  LAST_PENSION_SLIPS: 'lastPensionSlip',
  SECOND_LAST_PENSION_SLIPS: 'penultimatePensionSlip',
  RESIDENCE_PERMIT: 'residencePermit',
};
export const vatNumber = '05477800873';
export const BOOKING_ATTACHMENT_TYPES = {
  BOOKING_RECEIPT: 'Booking receipt',
};

export const CONTRACT_TYPE = {
  TEMPORARY: {
    label: 'Transitorio',
    value: 'temporary',
  },
  TEMPORARY_RENT_TO_RENT: {
    label: 'Temporary rent to rent',
    value: 'temporary_rent_to_rent',
  },
  TEMPORARY_STUDENT: {
    label: 'Transitorio Studenti',
    value: 'temporary_student',
  },
  '3+2': {
    label: '3+2',
    value: '3+2',
  },
  '4+4': {
    label: '4+4',
    value: '4+4',
  },
};

export const TYPE_OF_TAX = {
  WITH_FLAT_TAX: {
    label: 'Con cedolare secca',
    value: 1,
  },
  WITHOUT_FLAT_TAX: {
    label: 'Senza cedolare secca',
    value: 0,
  },
};

export const RENTAL_AGREEMENT = {
  FREE_FEE: {
    label: 'Canone Libero',
    value: 'canone_libero',
  },
  AGREED_FEE: {
    label: 'Canone Concordato',
    value: 'canone_concordato',
  },
};

export const YES_AND_NO = {
  YES: { label: 'Sì', value: 1 },
  NO: { label: 'No', value: 0 },
};

export const EXPENSES = {
  WATER: {
    label: 'Aqua',
    value: 'acqua',
  },
  GAS: {
    label: 'Gas',
    value: 'gas',
  },
  ELECTRICITY: {
    label: 'Elettricità',
    value: 'elettricità',
  },
  GARBAGE: {
    label: 'Tari',
    value: 'tari',
  },
  CONDOMINIO: {
    label: 'Condominio',
    value: 'condominio',
  },
};

export const LANDLORD_REASON = {
  TEMPORARY_JOB_IN_DIFFERENT_CITY: {
    label:
      'Contratto di lavoro a tempo determinato in un comune diverso da quello di residenza',
    value:
      'Contratto di lavoro a tempo determinato in un Comune diverso da quello di residenza',
  },
  WORKING_NEEDS: {
    label: 'Transferimento fuori sede per comprovate esigenze lavorative',
    value: 'Trasferimento fuori sede per comprovate esigenze lavorative',
  },
  RETURNING_FROM_ABROAD: {
    label: 'Rientro da un periodo all’estero',
    value: 'Rientro da un periodo all’estero',
  },
  ASSISTING_FAMILY: {
    label:
      'Necessità di assistere familiari lontani del proprio comune di residenza',
    value:
      'Necessità di assistere familiari lontani dal proprio Comune di residenza',
  },
  STAGES_OR_MASTERS: {
    label:
      'Stage di lavori o master universitari, in quanto hanno durata minore rispetto ad un ciclo di laurea triennale o magistrale',
    value:
      'Stage di lavoro o master universitari, in quanto hanno durata minore rispetto ad un ciclo di laurea triennale o magistrale',
  },
  RENOVATIONS: {
    label:
      'Lavori di ristrutturazione che redono inutilizzabili la propria abitazione',
    value:
      'Lavori di ristrutturazione che rendono inutilizzabile la propria abitazione',
  },
};

export const PROPERTY_TYPE = {
  PORTION: {
    label: "Porzione d'immobile",
    value: "porzione d'immobile",
  },
  ENTIRE: {
    label: 'Immobile Intero',
    value: 'immobile intero',
  },
};

export const R2R_USER_ID = 18;
export const CONTRACT_GESTIONE =
  'https://drive.google.com/file/d/1WgdU4B6EAfILfeNVPVchN5uFNHZf43cE/view?usp=sharing';
export const CONTRACT_LOCAZIONE =
  'https://drive.google.com/file/d/1HTRTs-lSoWF7GIaepZCoza9hpCUDOEKJ/view?usp=sharing';
